<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：首页 > 审核记录</div>
<!--      <div class="curse-btn" @click="to(`/formsub`)">添加项目</div>-->
      <router-link class="curse-btn" :to="`/adminhome/declarelist?keyword=${search.keyword}&organ_id=${search.organ_id}&approve_status=${search.approve_status}&time=${JSON.stringify(search.time)}&project_class=${search.project_class}&project_direction=${search.project_direction}&organ_class=${search.organ_class}&province_id=${search.province_id}&city_id=${search.city_id}&page=${search.page}`">
        返回
      </router-link>
    </div>
    <div class="list-content">
<!--      <div class="search-box">-->
<!--        <div class="search-item">-->
<!--          <el-input v-model="keyword" placeholder="机构名称"></el-input>-->
<!--        </div>-->
<!--        <div class="search-item">-->
<!--          <el-button type="primary" icon="el-icon-refresh" @click="searchreset">重置</el-button>-->
<!--          <el-button type="primary" icon="el-icon-search" @click="searchFun">搜索</el-button>-->
<!--        </div>-->
<!--      </div>-->
      <el-table
        :data="list"
        border
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="project_name"
          label="项目名称">
        </el-table-column>
        <el-table-column
          prop="admin_name"
          label="审核人">
        </el-table-column>
        <el-table-column
          prop="approve_time"
          label="审核时间">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="操作">
        </el-table-column>
      </el-table>

<!--      <div class="page-box flex justify-center padding-top-sm">-->
<!--        <el-pagination-->
<!--          class="page-all margin-bottom"-->
<!--          background-->
<!--          @current-change="init"-->
<!--          :current-page.sync="page"-->
<!--          :page-size="limit"-->
<!--          layout="prev, pager, next"-->
<!--          :total="total"-->
<!--        >-->
<!--        </el-pagination>-->
<!--      </div>-->
    </div>

  </div>
</template>
<script>
import {zhDate} from "@/tools";
import {baseURL} from "@/config";
import {getProjectApproveRecordList} from "@/api/admin";
export default {
  name: "index",
  data() {
    return {
      dialog:false,
      row:{},
      zhDate:zhDate,
      baseURL:baseURL,
      list: [],
      search: {
        keyword: '',
        organ_id: '',
        approve_status: '',
        time: [],
        project_class: '',
        project_direction: '',
        organ_class: '',
        province_id: '',
        city_id: '',
        page: 1,
      },
    }
  },
  computed: {
    token() {
      return this.$store.state.admintoken
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 1
    })
    this.id = this.$route.query.id
    this.search.keyword = this.$route.query.keyword
    this.search.organ_id = this.$route.query.organ_id
    this.search.approve_status = this.$route.query.approve_status
    this.search.time = JSON.parse(this.$route.query.time)
    this.search.project_class = this.$route.query.project_class
    this.search.project_direction = this.$route.query.project_direction
    this.search.organ_class = this.$route.query.organ_class
    this.search.province_id = this.$route.query.province_id
    this.search.city_id = this.$route.query.city_id
    this.search.page = this.$route.query.page
    this.init()
  },
  methods: {
    // 获取列表
    async init() {
      let _data = await getProjectApproveRecordList(
        this.id
      );
      if (_data.code === 200) {
        this.list = _data.data
      } else {
        this.$message.error(_data.message)
      }
    },

    searchFun(){
      this.page = 1
      this.init()
    },

    searchreset(){
      this.keyword = ''
      this.page = 1
      this.init()
    },

    handleEdit(row){
      this.row = row
      this.dialog = true
    },

    watchState(data){
      if(data) {
        this.init()
      }
      this.dialog = false
    },

    to(path){
      this.$router.push(path)
    }
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .search-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .search-item {
        width: 33.3%;
        padding-right: 20px;
        margin-bottom: 20px;
      }
    }


  }
}
</style>


